<tui-progress-segmented
  [value]="value"
  [max]="max"
  [size]="size"
  [colors]="colors"
></tui-progress-segmented>
